import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { vercelEnv } from "@api/const";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

const env = vercelEnv ? vercelEnv : "development"; // Vercel exposes VERCEL_ENV
// Vercel exposes VERCEL_ENV
const faviconMap: Record<string, string> = {
  development: "favicon_alt.ico",
  preview: "favicon_alt.ico",
  production: "favicon.ico",
};

const favicon = faviconMap[env]; // fallback to dev

const link: HTMLLinkElement | null = document.querySelector("#dynamic-favicon");

if (link) {
  link.href = `${process.env.PUBLIC_URL}/${favicon}`;
}

interface Metric {
  name: "CLS" | "FCP" | "FID" | "LCP" | "TTFB";
  value: number;
  delta: number;
  id: string;
  isFinal: boolean;
  entries: PerformanceEntry[];
}

function sendToAnalytics(metric: Metric) {
  return;
  // const body = JSON.stringify(metric);
  // const url = "https://example.com/analytics";

  // if (navigator.sendBeacon) {
  //   navigator.sendBeacon(url, body);
  // }
}

reportWebVitals(sendToAnalytics);
